import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TableModule } from 'primeng/table';
import { aButtonsCaption, aFuncionalButtons, aIconsCaption, aTableOptions, ametadata, ametadatatable } from '../../domain/a.table.interface';
import { Table } from 'primeng/table';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { dropdownItems, UtilService } from 'src/app/services/util.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { appDisabled } from 'src/app/shared/directives/disabled-control.directive';

@Component({
  selector: 'app-a-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    InputTextModule,
    DatePickerModule,
    ButtonModule,
    InputNumberModule,
    SelectModule,
    CheckboxModule,
    IconFieldModule,
    InputIconModule,
    ConfirmDialogModule,
    TooltipModule,
    ConfirmPopupModule,
    appDisabled
  ],
  templateUrl: './a-table.component.html',
  styleUrl: './a-table.component.css'
})
export class ATableComponent {

  constructor(
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    public readonly util: UtilService,
  ) { }

  //#region Variables de entrada
  @ContentChild('addHeaderStart', { static: true }) addHeaderStart!: TemplateRef<any>
  @ContentChild('addBodyStart', { static: true }) addBodyStart!: TemplateRef<any>
  @ContentChild('addCaption', { static: true }) addCaption!: TemplateRef<any>
  @Input() dataTable: any[];                      // Datos de la tabla
  @Input() metadataTable: ametadatatable[] = []   // Estructura de la tabla
  @Input() stripedRows: boolean = false           // Intercala lineas visualmente una blanca una gris
  @Input() dataKey: string                        // Key que idintifica el codigo de la informacion
  @Input() editMode: "row" | "cell" = null       // Tipo de edit por fila o todos habilitados
  @Input() buttonCaption: aButtonsCaption[] = []  // Lista de botones para el caption
  @Input() deleteMode: "row" | "list" | "" = ""   // Forma de eliminar registros por fila o los que selecciono
  @Input() addRow: boolean = false                // Habilita un boton para agregar mas datos a la tabla
  @Input() deleteRow: boolean = false             // Habilita un boton para eliminar filas una a una o las seleccionadas
  @Input() funcionalButtons: aFuncionalButtons[] = [] // Habilita los botones funcionales por cada fila
  @Input() paginator: boolean = false
  @Input() rowsPerPageOptions: number[] = [50, 100, 150]
  // @Input() styleRow: (row) => any = null
  @Input() styleRow: (row: any) => { [key: string]: string } = () => ({});
  // @Input() onAddEmptyRow: (row: any) => any
  @Output() addEmptyRowEvent = new EventEmitter<any>();
  @Output() onInputChangeEvento = new EventEmitter<any>();
  @Input() btnDisabled: boolean = false;
  @Input() checkAllOn: boolean = true;
  @Input() checkOn: boolean = true;
  @Input() checkInicial: boolean = true;
  @Input() optionTable: aTableOptions
  @Input() virtualScroll: boolean = false
  @Input() editRow: boolean = false
  @Input() iconSave: boolean = true
  @Input() customLeyendasHex: { color?: string; texto?: string }[] = [];
  @Input() btnResetFiltros: boolean = false;
  @Input() exportDataCsv: boolean = false;
  @Input() footerTotalFields: string[] = [];
  // 1. Nuevo Input para que el padre pueda establecer el estado
  @Input()
  set estadoCheckCabecera(value: boolean) {
    // Cuando el padre actualiza esta propiedad, actualizamos la variable interna
    this.checkAllStateCabecera = value;
  }
  //#endregion

  @ViewChild('dt') dt: Table;

  @Input() prueba: ametadata[] = []
  @Output()
  dataTableChange = new EventEmitter<any[]>();

  messageException: string = ""
  filtrosGlobal: string[] = []

  //#region Leyenda

  // codeinterno: Nuevo codigo para operaciones internas
  // statustable: Estado de las filas (E: existente, I: nuevo, U: modificado, D: eliminado)
  // checked: Filas seleccionadas

  //#endregion

  ngOnInit(): void {
    // this.initialdataTable = this.dataTable.map((r, i) => ({ ...r, codeinterno: i, statustable: r.statustable ?? "E", checked: false }))
    this.validateKeysDatatable()
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.initialdataTable)
    // console.log(this.dataTable)
    // this.initialdataTable = this.dataTable.map((r, i) => ({ ...r, codeinterno: (r.codeinterno ? r.codeinterno : i), statustable: r.statustable ?? "E", checked: false }))

    this.metadataTable.forEach(r => {
      this.filtrosGlobal.push(r.field.output.toString())
    })

    // this.metadataTable = this.metadataTable

  }

  validateKeysDatatable() {
    const invalid = this.dataTable.some((r: any) => Object.keys(r).includes('codeinterno') || Object.keys(r).includes('statustable') || Object.keys(r).includes('checked'))
    if (invalid) {
      this.messageException = 'los datos de la tabla no pueden contener los nombres de codeinterno y statustable'
    }
  }

  initialdataTable: any[] = []
  isSorted: boolean = null;
  customSort(event: SortEvent) {
    if (this.isSorted == null || this.isSorted === undefined) {
      this.isSorted = true;
      this.sortTableData(event);
    } else if (this.isSorted == true) {
      this.isSorted = false;
      this.sortTableData(event);
    } else if (this.isSorted == false) {
      this.isSorted = null;
      // this.dataTable = [...this.initialdataTable];
      this.dt.reset();
    }
  }

  sortTableData(event) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;
      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  }

  onChangeSelect(event, codigo: number, lista: any[], field: string) {
    try {
      const item = lista.find(r => r.value === event.value)
      if (item) {
        const row = this.dataTable.find(r => r.codeinterno === codigo)
        row[field] = item.label
        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }
      }
    } catch (error) {
      this.messageException = error
    }
  }

  onChangeSelectCoin(event, codigo: number, lista: any[], field: string) {
    try {
      const item = lista.find(r => r.value === event.value)
      if (item) {
        const row = this.dataTable.find(r => r.codeinterno === codigo)
        row[field] = item.value
        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }
      }
    } catch (error) {
      this.messageException = error
    }
  }

  onChangeInput(event, codigo: number) {
    try {
      if (event) {
        const row = this.dataTable.find(r => r.codeinterno === codigo)
        if (row["statustable"] === "E") {
          row["statustable"] = "U"
        }
      }
    } catch (error) {
      this.messageException = error
    }
  }


  /**
   * Función para agregar una nueva fila en la tabla
   *
   * - Genera un nuevo "codeinterno" unico que no este en uso
   * - Copia la estructura de dataTable y define los campos en null
   * - Establece statustable como I (Nuevo)
   */
  addEmptyRow(): void {
    try {
      const usedCodes = this.dataTable.map(row => row.codeinterno)

      let newCode = 0
      while (usedCodes.includes(newCode)) {
        newCode++
      }

      const baseStructure = this.dataTable[0] || {};
      const newRow: any = {}

      Object.keys(baseStructure).forEach(key => {
        newRow[key] = null
      });

      newRow.codeinterno = newCode
      newRow.statustable = 'I'
      newRow.checked = false

      // if (this.onAddEmptyRow) {
      //   this.onAddEmptyRow(newRow);
      // }

      this.dataTable.push(newRow)
      this.addEmptyRowEvent.emit(newRow)

    } catch (error) {
      this.messageException = error
    }
  }

  /**
   * Función para eliminar una fila nueva o cambia a estado D en una fila existente
   *
   * @param codigo - codigo interno de la fila
   */
  deleteRowByCode(codigo: number) {
    try {

      const item = this.dataTable.find(r => r.codeinterno === codigo)
      if (item && (item.statustable === "E" || item && item.statustable === "U")) {
        item.statustable = "D"
        item.checked = false
      } else {
        this.dataTable = this.dataTable.filter(r => r.codeinterno !== codigo)
      }

    } catch (error) {
      this.messageException = error
    }
  }

  /**
   * Función para eliminar las filas seleccionadas
   *
   * - Verificamos que existe al menos una fila seleccionada
   * - Ubicamos los codigo de las filas a actualizar a D y las que se eliminaran
   * - Actualizamos en base a la lista "codesToMarkDeleted"
   * - Eliminamos en base a la lista "codesToDelete"
   */
  deleteCheckList() {
    try {

      const noneSelected = this.dataTable.every(row => !row.checked)
      if (noneSelected) {
        this.messageService.add({ severity: 'error', summary: 'Eliminar Filas', detail: 'Es necesario marcar al menos una fila.', life: 3000 });
        return
      }

      const codesToDelete: number[] = []
      const codesToMarkDeleted: number[] = []

      this.dataTable.forEach(r => {
        if (r.checked) {
          if (r.statustable === "E" || r.statustable === "U") {
            codesToMarkDeleted.push(r.codeinterno)
          } else {
            codesToDelete.push(r.codeinterno)
          }
        }
      })

      this.dataTable.forEach(row => {
        if (codesToMarkDeleted.includes(row.codeinterno)) {
          row.statustable = "D"
          row.checked = false
        }
      });

      this.dataTable = this.dataTable.filter(
        row => !codesToDelete.includes(row.codeinterno)
      );

    } catch (error) {
      this.messageException = error
    }
  }


  checkAllState: boolean = false
  checkAllStateCabecera: boolean = false
  /**
   * Funcion que evalua que todos los checks esten marcados para habilitar el "checkAllState"
   */
  onChangeListCheck() {
    try {
      const allChecked = this.dataTable.every(row => row.checked === true);
      this.checkAllState = allChecked;

    } catch (error) {
      this.messageException = error
    }
  }

  /**
   * Funcion para marcar o desmacar todas las filas habiles
   *
   * @param event - evento de checkbox para saber si es true o false
   */
  checkAll(event: CheckboxChangeEvent): void {
    try {
      const isChecked = event.checked
      this.dataTable.forEach(row => { if (row.statustable !== 'D') { row.checked = isChecked } })
    } catch (error) {
      this.messageException = error
    }
  }

  /**
    * Funcion para marcar o desmarcar todas las filas habiles
    * @param event - evento de checkbox
    * @param fieldName - El nombre del campo a actualizar (e.g., "check_seleccionados")
    */
  checkAllPorCabecera(event: any, fieldName: string): void { // Asegúrate de que 'any' sea CheckboxChangeEvent si lo tienes
    try {
      const isChecked = event.checked;

      this.dataTable.forEach(row => {
        // Solo si la fila no está marcada como eliminada ('D')
        if (row.statustable !== 'D') {
          // 3. Usa el nombre del campo pasado
          row[fieldName] = isChecked;
        }
      });

      // 4. Emite el cambio de la tabla para que el padre la refresque y actualice validaciones
      this.dataTableChange.emit(this.dataTable);

    } catch (error) {
      console.error(error);
    }
  }

  public getCheckedRows(): any[] {
    return this.dataTable.filter(row =>
      row.checked === true && row.statustable !== 'D'
    )
  }

  //#region Funciones de conversion

  convertDateFormat(fecha: any, formato: string) {
    if (!(fecha instanceof Date) || isNaN(fecha.getTime())) {
      return "";
    }

    fecha = new Date(fecha)

    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // getMonth() es base 0
    const anio = fecha.getFullYear();
    const horas = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');

    switch (formato) {
      case 'date':
        return `${dia}/${mes}/${anio}`;
      case 'datetime':
        return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
      default:
        return "";
    }
  }

  //#endregion

  getMonedaLabel(codigo: string): string {
    const moneda = this.listMoneda.find(r => r.value === codigo);
    return moneda ? moneda.label : '';
  }

  //#region CONSTANTES

  listMoneda: dropdownItems[] = [
    { label: "PEN", value: "001" },
    { label: "USD", value: "002" },
    { label: "EUR", value: "003" }
  ]

  //#endregion

  functionClick(col: any, rowData: any) {
    try {
      const confirm = col.confirmFunction
      const func = col.function
      if (confirm) {

        this.confirmationService.confirm({
          target: event.target as EventTarget,
          dismissableMask: false,
          message: '¿Desea continuar la operación?',
          header: 'Confirmación',
          closable: true,
          closeOnEscape: true,
          icon: 'pi pi-exclamation-triangle',
          rejectButtonProps: {
            label: 'Cancelar',
            severity: 'secondary',
            outlined: true,
          },
          acceptButtonProps: {
            label: 'Guardar',
          },
          accept: () => {
            func(rowData);
          },
          key: "cd"
          // reject: () => {
          //   this.messageService.add({
          //     severity: 'error',
          //     summary: 'Rejected',
          //     detail: 'You have rejected',
          //     life: 3000,
          //   });
          // },
        })

      } else {
        func(rowData);
      }
    } catch (error) {
      this.messageException = error
    }

  }

  //#region Funciones de retorno

  getCheckList(): number[] {
    const items = this.dataTable.slice().filter(row => row.checked).map(row => row.codeinterno)
    return items;
  }

  getDataTable() {
    return this.dataTable
  }

  //#endregion

  viewData() {
    console.log(this.dataTable)
    console.log(this.metadataTable)
    console.log(this.dataTable.findIndex(r => r.checked === true))
  }
  formatNumber(value: any, type: string): string {
    if (type == 'percentage') {
      let valor = '0'
      if (isNaN(value)) {
        valor = '0 %'
      } else {
        valor = (value).toFixed(0) + ' %'
      }
      return valor
    }
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return type === 'decimal' ? '0.00' : '0';
    let decimalPlaces = type === 'decimal' ? 2 : (Math.floor(numberValue) === numberValue ? 0 : 1);
    const fixedNumber = numberValue.toFixed(decimalPlaces);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }

  checkLists: { [key: string]: any[] } = {}
  onChangeCheckList(event: any, row: any, col: any): void {
    const key = col.field.output
    if (!this.checkLists[key]) {
      this.checkLists[key] = []
    }

    if (event.checked) {
      this.checkLists[key].push(row)
    } else {
      this.checkLists[key] = this.checkLists[key].filter(item => item.index !== row.index)
    }
  }

  resetCheckLists() { this.checkLists = {}; }

  resetCheckListsPorKey(key: string) {
    // console.log(this.checkLists)
    // console.log(key)
    // console.log(this.checkLists[key])
    if (this.checkLists[key]) {
      this.checkLists[key] = [];
    }
  }

  resetCheckListsElementoPorKey(key: string, elemento: any) { // elimina el elemento enviado
    if (this.checkLists[key]) {
      this.checkLists[key] = this.checkLists[key].filter(item => item !== elemento);
    }
  }

  getDisabledSelectEdit(condicion: any, descripcion: any): boolean {
    if (condicion !== undefined || condicion != null) {
      if (descripcion !== undefined && descripcion == null) {
        if (String(condicion) === descripcion) {
          return true; // Deshabilitar si la condición es igual a la descripción
        } else {
          return false; // No deshabilitar si la condición no es igual a la descripción
        }
      } else {
        return condicion; // Usar el valor booleano de la condición directamente
      }
    } else {
      return false; // Por defecto, no deshabilitar
    }
  }
  convertToDecimal(value: any, decimalPlaces: number = 2): string {
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return '0.00';
    const fixedNumber = numberValue.toFixed(decimalPlaces);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }

  formatPorcentaje(value: any, decimales: number = 2): string {
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return '0.00%';
    const fixedNumber = numberValue.toFixed(decimales);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart}%`;
  }

  getFooterTotal(field: string, type: string = 'int'): string {
    let total = 0;
    (this.dt?.filteredValue || this.dataTable || []).forEach(r => {
      const valor = parseFloat(r[field]);
      total += !isNaN(valor) ? valor : 0;
    });
    if (type === 'porcentaje') return this.formatPorcentaje(total, 2);
    return type === 'decimal' ? this.convertToDecimal(total) : this.formatNumber(total, 'int');
  }

  export() {
    if (!this.dataTable || this.dataTable.length === 0) {
      console.warn('No hay datos para exportar.');
      return;
    }
    let nuevadata = [];
    this.dataTable.forEach(row => {
      const newItem = {};
      this.metadataTable.forEach(e => {
        newItem[e.header.title.toUpperCase()] = row[e.field.output];
      });
      nuevadata.push(newItem);
    });
    const data = [{ data: nuevadata, cabeceras: [] }];
    this.util.ExportarExcel(data, 'Reporte.xlsx', false);
  }

  onChangeGeneric(event: any, row: any, col: any, codigo: number): void {
    const key = col.field.output;
    if (!this.checkLists[key]) {
      this.checkLists[key] = [];
    }

    let value: any = null;
    switch (col.type) {
      case 's-input':
      case 's-area':
        value = event?.target?.value ?? null;
        break;
      case 's-select':
      case 's-datetime':
        value = event?.value ?? event ?? null;
        break;
    }

    const idx = this.checkLists[key].findIndex(item => item.codeinterno === row.codeinterno);

    if (value !== null && value !== '') {
      if (idx === -1) {
        this.checkLists[key].push(row); // guarda la fila si no está
      } else {
        this.checkLists[key][idx] = row; // si ya existe, actualiza la fila
      }
    } else {
      if (idx !== -1) {
        this.checkLists[key].splice(idx, 1);
      }
    }

    try {
      const rowFound = this.dataTable.find(r => r.codeinterno === codigo);
      if (rowFound?.statustable === 'E') {
        rowFound.statustable = 'U';
      }
    } catch (error) {
      this.messageException = error;
    }

    // console.log("this.checkLists", this.checkLists);
  }



  clonedRow: { [s: string]: any } = {};
  onRowEditInit(row: any) {
    this.clonedRow[row.codeinterno as string] = { ...row };
  }

  onRowEditSave(row: any) {

    const originalRow = this.clonedRow[row.codeinterno as string];
    const hasChanges = !this.objectsAreEqual(originalRow, row);

    if (row.statustable !== 'I') {
      if (hasChanges) {
        row.statustable = 'U'
        this.messageService.add({ severity: 'success', summary: 'Editar', detail: 'La fila se edito correctamente.' })
      } else {
        this.messageService.add({ severity: 'error', summary: 'Editar', detail: 'No se detectaron cambios.' })
      }
    }


    delete this.clonedRow[row.codeinterno as string];

  }

  onRowEditCancel(row: any, index: number) {
    this.dataTable[index] = this.clonedRow[row.codeinterno as string];
    delete this.clonedRow[row.codeinterno as string];
  }

  objectsAreEqual(obj1: any, obj2: any): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  }

  getIconClass(iconCaption: aIconsCaption): string {
    if (!iconCaption) return "";

    const severityMap: Record<string, { color: string; icon: string }> = {
      success: { color: "text-green-500", icon: "pi pi-check-circle" },
      info: { color: "text-blue-500", icon: "pi pi-info-circle" },
      warn: { color: "text-yellow-500", icon: "pi pi-exclamation-triangle" },
      danger: { color: "text-red-500", icon: "pi pi-times-circle" },
      help: { color: "text-purple-500", icon: "pi pi-question-circle" },
      primary: { color: "text-blue-600", icon: "pi pi-star" },
      secondary: { color: "text-gray-500", icon: "pi pi-circle" },
      contrast: { color: "text-black", icon: "pi pi-ban" }
    };

    const severity = iconCaption.severity ?? "info";
    const severityConfig = severityMap[severity];

    if (!severityConfig) {
      console.warn("Severity no reconocida:", severity);
      return iconCaption.icon ?? "pi pi-question-circle text-gray-400";
    }

    const icon = iconCaption.icon || severityConfig.icon;
    return `${icon} ${severityConfig.color}`;
  }




}
